<template>
  <section class="bg-site-600 justify-around flex pb-20 flex-wrap-reverse">
    <article class="w-full lg:w-auto  flex flex-wrap flex-col items-center py-10 lg:py-0">
      <h3 class="text-6xl md:text-5xl text-white text-shadow-pop-left"> {{$t('social-media')}}</h3>
      <p class="text-white text-lg my-4 lg:text-md ">{{$t('social-media-subtitle')}}</p>
      <social-section class="flex flex-wrap mt-2"
       icon-class="text-4xl  md:text-5xl mx-2 cursor-pointer"
       :social="socialMedia" img-class="md:h-14 h-10 mx-2"
        :is-light="false"></social-section>
    </article>
    <aside class="  w-full lg:w-1/2 flex flex-col items-center py-8 md:py-0 ">
      <h3 class="text-6xl md:text-5xl text-white text-shadow-pop-left">{{$t('skills-tools')}}</h3>
        <p class="text-white text-lg  my-4 px-4">{{$t('skills-tools-subtitle')}}</p>
      <carousel-skill class="lg:px-0"></carousel-skill>
    </aside>
  </section>
</template>
<script>
import CarouselSkill from '@/views/about/carousel/CarouselSkill.vue';
import { socialMedia } from '@/data/contact';
import SocialSection from '@/components/SocialSection.vue';

export default {
  name: 'SkillContent',
  components: {
    CarouselSkill,
    SocialSection,
  },
  data() {
    return {
      socialMedia,
    };
  },
};
</script>
<style scoped>
</style>
